import { render, staticRenderFns } from "./HuliProjects.vue?vue&type=template&id=59469b2f&scoped=true"
import script from "./HuliProjects.vue?vue&type=script&lang=js"
export * from "./HuliProjects.vue?vue&type=script&lang=js"
import style0 from "./HuliProjects.vue?vue&type=style&index=0&id=59469b2f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59469b2f",
  null
  
)

export default component.exports